// extracted by mini-css-extract-plugin
module.exports = {"primary":"#2196f3","secondary":"#4caf50","accent":"#e64a19"};